import { If } from "components";
import { t } from "i18next";
import { useGetProductsByFilter } from "modules/products";
import { Modal } from "ui";

import { useDeleteUsageGuide } from "../../../apis";
import { DeleteUsageGuideModalProps } from "./DeleteUsageGuideModal.types";

import styles from "./DeleteUsageGuideModal.module.scss";

const DeleteUsageGuideModal = ({
  isOpen,
  guideId,
  categoryId,
  onClose,
  onDeleted
}: DeleteUsageGuideModalProps) => {
  const deleteUsageGuide = useDeleteUsageGuide({
    onSuccess: () => {
      onClose();
      onDeleted?.();
    }
  });

  // One page of one item, purely for `meta.itemCount`. The filter matches the
  // whole subtree under the category, which is the same set that inherits the
  // guide. It counts variants rather than products, so the copy says so.
  const { meta } = useGetProductsByFilter(
    { page: 1, take: 1, categoryId },
    { enabled: isOpen && Boolean(categoryId) }
  );

  const affectedVariantsCount = meta?.itemCount;

  return (
    <Modal
      type="delete"
      isOpen={isOpen}
      title="Delete guide"
      isLoading={deleteUsageGuide.isLoading}
      okText="Delete"
      onOk={() => deleteUsageGuide.mutate(guideId)}
      contentClassName={styles.modal}
      onClose={onClose}
    >
      <p className={styles.modal_text}>
        {t(
          "Are you sure you want to delete this guide? Its questions are deleted with it."
        )}
      </p>

      <If condition={Boolean(categoryId) && affectedVariantsCount !== undefined}>
        {/* Not `count`: that key name switches i18next into plural
            resolution, which these single-form strings do not have. */}
        <p className={styles.modal_warning}>
          {t(
            "This is a category guide — {{variantsCount}} product variants under this category will lose the section.",
            { variantsCount: affectedVariantsCount }
          )}
        </p>
      </If>
    </Modal>
  );
};

export default DeleteUsageGuideModal;
